import React from "react";
import { Brain } from "lucide-react"; // brain icon
import { useNavigate } from "react-router-dom";

const GameLauncher = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/game"); // navigate to /game route
  };

  const iconStyle = {
    fontSize: "72px",
    cursor: "pointer",
    color: "#ffcc00",
    position: "fixed",
    bottom: "30px",
    left: "30px",
    zIndex: 100,
    transition: "transform 0.2s",
  };

  return (
    <Brain
      style={iconStyle}
      onClick={handleClick}
      title="Boost Your Ads Game"
    />
  );
};

export default GameLauncher;
